import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faUser,
  faSignOutAlt,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const NavbarWithWebSocket = ({ isSidebarOpen, onToggleSidebar }) => {
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const notificationsRef = useRef();
  const userMenuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleClick = () => onToggleSidebar();

  const handleBellClick = () => {
    setShowNotifications((prev) => !prev);
  };

  const handleUserIconClick = () => setShowUserMenu((prev) => !prev);

  const handleLogout = () => {
    Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#4f46e5",
      cancelButtonColor: "#ef4444",
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "rounded-xl shadow-lg",
        confirmButton: "bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-md",
        cancelButton: "bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded-md",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        window.location.reload();
      }
    });
  };

  const handleChangePasswordClick = () => {
    navigate("/change-password");
  };

  return (
    <div
      className={`bg-gradient-to-r from-gray-50 to-indigo-50 shadow-md border-b-1 border-gray-200 h-20 flex items-center justify-between px-6 fixed top-0 ${isSidebarOpen ? "left-72" : "left-20"} right-0 z-40 transition-all duration-300`}
    >
      {/* Toggle Button */}
      <button
        className="text-blue-600 hover:text-blue-800 transition-colors p-3 rounded-full hover:bg-blue-100"
        onClick={handleToggleClick}
      >
        <FontAwesomeIcon icon={faBars} className="text-2xl" />
      </button>

      {/* Title */}
      <h1 className="text-xl font-bold text-gray-900 tracking-tight">Billing & Collection Portal</h1>

      {/* Icons Section */}
      <div className="flex items-center gap-6">
        {/* Notification Bell */}
        <div className="relative" ref={notificationsRef}>
          <button
            className="text-purple-600 hover:text-purple-800 transition-colors p-3 rounded-full hover:bg-purple-100"
            onClick={handleBellClick}
          >
            <FontAwesomeIcon icon={faBell} className="text-2xl" />
          </button>
          {showNotifications && (
            <div className="absolute right-0 mt-3 w-80 bg-white border border-gray-200 rounded-xl shadow-xl max-h-64 overflow-y-auto">
              <div className="p-4 text-gray-500 text-sm text-center">
                No recent notifications
              </div>
            </div>
          )}
        </div>

        {/* User Icon / Menu */}
        <div className="relative" ref={userMenuRef}>
          <button
            className="text-red-600 hover:text-red-800 transition-colors p-3 rounded-full hover:bg-red-100"
            onClick={handleUserIconClick}
          >
            <FontAwesomeIcon icon={faUser} className="text-2xl" />
          </button>
          {showUserMenu && (
            <div className="absolute right-0 mt-3 w-52 bg-white border border-gray-200 rounded-xl shadow-xl">
              <button
                className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-indigo-100 hover:text-indigo-800 rounded-t-md transition-colors"
                onClick={() => navigate("/profile")}
              >
                Profile
              </button>
              <button
                className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-indigo-100 hover:text-indigo-800 transition-colors"
                onClick={handleChangePasswordClick}
              >
                Change Password
              </button>
              <button
                className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-indigo-100 hover:text-indigo-800 rounded-b-md transition-colors"
                onClick={handleLogout}
              >
                <FontAwesomeIcon icon={faSignOutAlt} className="mr-2 text-red-600" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavbarWithWebSocket;